var ajaxCart = (function(module, $) {
  'use strict';

  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  init = function (options) {
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    $.extend(settings, options);

    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $(document.body);
    isUpdating = false;

    if (settings.enableQtySelectors) qtySelectors && qtySelectors();
    if (!settings.disableAjaxCart && $addToCart.length) formOverride();
    adjustCart && adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  function updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if (cart.item_count === 0) $cartCountSelector.addClass('hidden-count');
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function formOverride() {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      $addToCart.removeClass('is-added').addClass('is-adding');
      $('.qty-error').remove();
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  }

  function itemAddedCallback(product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  }

  function itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    if (!!data.message && data.status == 422) {
      $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
    }
  }

  function cartUpdateCallback(cart) {
    updateCountPrice(cart);
    buildCart(cart);
    updateMiniCart(cart);
  }

  function buildCart(cart) {
    $cartContainer.empty();
    if (cart.item_count === 0) {
      $cartContainer.append('<p>Your cart is empty</p>');
      cartCallback(cart);
      return;
    }

    var source = $("#CartTemplate").html();
    var template = Handlebars.compile(source);
    var items = cart.items.map(function(cartItem, index) {
      var img = cartItem.image
        ? cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '')
        : '//cdn.shopify.com/s/assets/admin/no-image-medium.gif';

      return {
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        img: img,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price !== cartItem.original_line_price
      };
    });

    var data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount !== 0
    };

    $cartContainer.append(template(data));
    cartCallback(cart);
  }

  function cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    setTimeout(function () {
      $('.shopping-cart-delete a').each(function() {
        this.addEventListener('mouseup', function () {
          this.blur();
        });
      });
    }, 100);
  }

  // ✅ ATNAUJINTA: mini-cart atvaizdavimas su 30% nuolaida DaugiametisRusis tagui
  function updateMiniCart(cart) {
    const cartItemsEl = document.querySelector('.cart-items');
    const cartCountEl = document.querySelector('.bigcounter');
    const cartTotalEls = document.querySelectorAll('.shopping-cart__total');
    const moneyFormat = window.money_format || '$';

    if (!cartItemsEl) return;

    if (cartCountEl) cartCountEl.textContent = cart.item_count;

    cartTotalEls.forEach(el => {
      el.textContent = Shopify.formatMoney(cart.total_price, moneyFormat);
    });

    cartItemsEl.innerHTML = '';

    cart.items.forEach(item => {
      const li = document.createElement('li');
      li.className = 'single-shopping-cart';

      const imgUrl = item.image
        ? item.image.replace(/(\.[^.]*)$/, '_small$1')
        : '//cdn.shopify.com/s/assets/admin/no-image.gif';

      const tags = (item.product && item.product.tags) || [];
      const isDiscounted = tags.includes('DaugiametisRusis');

      const price = item.line_price;
      const original = isDiscounted ? Math.round(price / 0.7) : price;

      const originalFormatted = Shopify.formatMoney(original, moneyFormat);
      const currentFormatted = Shopify.formatMoney(price, moneyFormat);

      const priceHTML = isDiscounted
        ? `<small class="regular-price"><s>${originalFormatted}</s></small><br><span class="discounted-price">${currentFormatted}</span>`
        : `<span class="regular-price">${currentFormatted}</span>`;

      li.innerHTML = `
        <div class="shopping-cart-img">
          <a href="${item.url}"><img alt="" src="${imgUrl}"></a>
        </div>
        <div class="shopping-cart-title">
          <h4><a href="${item.url}">${item.product_title}</a></h4>
          <h6>Kiekis: ${item.quantity}</h6>
          ${priceHTML}
        </div>
        <div class="shopping-cart-delete">
          <a href="javascript:void(0);" class="remove-x" onclick="Shopify.removeItem(${item.variant_id})" title="Remove this item">
            <i class="ion ion-close"></i>
          </a>
        </div>
      `;

      cartItemsEl.appendChild(li);
    });
  }

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
